import React, { useState, useRef, useEffect } from "react"
import { Row, Col, CardBody, Card, Container, Form, Input } from "reactstrap"
import { Link, useNavigate } from "react-router-dom"

import profile from "assets/images/logo.jpg"
import logo from "assets/images/logo.svg"

import "../../assets/css/Login/Login.css"
import Configs from "../../config"
import Swal from "sweetalert2"
import { FaShieldAlt } from "react-icons/fa"
import secureLocalStorage from "react-secure-storage"

const VerifyCode = () => {
  const navigate = useNavigate()

  document.title = "Verify Code | J. Kyle Cleaning Services"

  const [code, setCode] = useState(["", "", "", ""])
  const [error, setError] = useState("")

  const inputsRef = useRef([])

  // Focus first input on load
  useEffect(() => {
    inputsRef.current[0]?.focus()
  }, [])

  const handleChange = (value, index) => {
    if (!/^\d*$/.test(value)) return // Only allow digits

    const newCode = [...code]
    newCode[index] = value
    setCode(newCode)
    setError("")

    // Auto-focus next input
    if (value && index < 3) {
      inputsRef.current[index + 1].focus()
    }
  }

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputsRef.current[index - 1].focus()
    }
  }

  const handlePaste = e => {
    e.preventDefault()
    const pasted = e.clipboardData.getData("text").trim()
    if (/^\d{4}$/.test(pasted)) {
      setCode(pasted.split(""))
      inputsRef.current[3].focus()
    }
  }

  const validate = () => {
    const joinedCode = code.join("")
    if (joinedCode.length !== 4) {
      setError("Please enter all 4 digits")
      return false
    }
    return true
  }

  const authCod = secureLocalStorage.getItem("authCod")
  const email = authCod?.email

  const handleSubmit = async e => {
    e.preventDefault()
    if (!validate()) return
    const verificationCode = code.join("")

    try {
      if (Number(authCod?.code) === Number(verificationCode)) {
        Swal.fire({
          title: "Verified!",
          text: "Your email has been verified. You can now reset your password.",
          icon: "success",
          timer: 2000,
        })

        setTimeout(() => {
          navigate("/reset-password")
        }, 2200)
      } else {
        setError("Invalid or expired code")
        setCode(["", "", "", ""])
        inputsRef.current[0].focus()
      }
    } catch (err) {
      console.log(err)
      setError("Invalid or expired code")
    }
  }

  return (
    <React.Fragment>
      <div className="login-page">
        <div className="account-pages">
          <Container>
            <Row className="justify-content-end">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-darkblue pe-3">
                    <Row>
                      <Col xs={6}>
                        <div className="text-black p-4 pe-0">
                          <h5 className="text-white fw-bold">Verify Code</h5>
                          <p className="text-white">
                            We sent a 4-digit code to <br />
                            <strong>{email || "your email"}</strong>
                          </p>
                        </div>
                      </Col>
                      <Col className="col-6 align-self-center">
                        <div className="bg-white p-2">
                          <img
                            src={profile}
                            alt="Verify Code"
                            className="img-fluid"
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <CardBody className="pt-0">
                    <div className="text-center">
                      <Link
                        to={`${Configs.appurl}`}
                        className="logo-light-element"
                      >
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img src={logo} alt="Logo" height="34" />
                          </span>
                        </div>
                      </Link>
                    </div>

                    <div className="p-2">
                      <Form onSubmit={handleSubmit}>
                        <div className="mb-4 text-center">
                          <FaShieldAlt
                            size={50}
                            className="text-primary mb-3"
                          />
                          <h5>Enter Verification Code</h5>
                          <p className="text-muted">
                            Check your email for the 4-digit code
                          </p>
                        </div>

                        <div className="d-flex justify-content-center gap-3 mb-3">
                          {[0, 1, 2, 3].map(index => (
                            <Input
                              key={index}
                              type="text"
                              maxLength="1"
                              value={code[index]}
                              onChange={e =>
                                handleChange(e.target.value, index)
                              }
                              onKeyDown={e => handleKeyDown(e, index)}
                              onPaste={handlePaste}
                              innerRef={el => (inputsRef.current[index] = el)}
                              className="text-center fs-3 fw-bold"
                              style={{
                                width: "60px",
                                height: "60px",
                                borderRadius: "10px",
                                border: "2px solid #ced4da",
                              }}
                              autoComplete="off"
                            />
                          ))}
                        </div>

                        {error && (
                          <div className="text-center">
                            <span className="text-danger">{error}</span>
                          </div>
                        )}

                        <div className="mt-4 d-grid">
                          <button
                            type="submit"
                            className="btn btn-blue text-white btn-block"
                            disabled={code.join("").length !== 4}
                          >
                            Verify Code
                          </button>
                        </div>

                        <div className="mt-3 text-center">
                          <p className="text-muted mb-0">
                            Didn't receive code?{" "}
                            <Link
                              to="/forgot-password"
                              className="fw-bold text-primary"
                            >
                              Retry
                            </Link>
                          </p>
                        </div>

                        <div className="mt-4 text-center">
                          <Link to="/login" className="text-muted">
                            Back to Login
                          </Link>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default VerifyCode
